<template>
    <div class="animated fadeIn">
        <b-card no-body>
      <b-card-body v-if="reservation">
        <b-row>
            <b-col lg="4">
            <p><strong>Applicant:</strong></p>
            <p>
              {{ reservation.applicant_name }}
            </p>
          </b-col>
          <b-col lg="4">
            <p><strong>Total Members:</strong></p>
            <p>
              {{ reservation.members_count }}
            </p>
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="4">
            <p><strong>Comments:</strong></p>
            <p>
              {{ reservation.comments }}
            </p>
          </b-col>
          <b-col lg="8">
            <p><strong>Prefered Accommodation:</strong></p>
            <b-list-group>
              <b-list-group-item>Accomodation Type: {{ reservation.accomodation_type }}</b-list-group-item>
              <b-list-group-item>Toilet Type: {{ reservation.toilet_type }}</b-list-group-item>
              <b-list-group-item>AC Room: {{ reservation.ac_room }}</b-list-group-item>
            </b-list-group>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
        <b-card no-body>
            <b-card-body>             
                <b-row>
                    <b-col>
                        <b-form-group label="" >
                            <p><strong>Select Building:</strong></p>
                            <v-select id="buildingName" :options="buildings" v-model="$v.form.building.$model"
                                :reduce="building => building.id" label="name" placeholder="Building Name">                            
                            </v-select>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-button type="submit" variant="primary" :disabled="$v.form.$invalid || submitted || !reservation.id" @click="onSubmit">Submit</b-button>
                    </b-col>
                </b-row>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
import Vue from 'vue';
import { mapState, mapActions } from 'vuex'
import {
    required
} from "vuelidate/lib/validators"
import map from 'lodash/map'


const formShape = {
    building: "",
    is_edit: false
}
export default {
    name: 'ReservationBuildingModal',
    props: {
        reservation: Object
    },
    computed: {
        isValid() {
            return !this.$v.form.$anyError
        },
        isDirty() {
            return this.$v.form.$anyDirty
        },
        buildings() {
            return map(this.$store.state.buildings.simple, (building) => {
                return {
                    name: building.name,
                    id: building.id
                }

            })
        },

    },

    data() {
        return {
            form: Object.assign({}, formShape),
            submitted: false,
        }
    },
    validations: {
        form: {
            building: {
                required
            }
        }
    },
    methods: {
        onSubmit() {
            console.log(this.$v.form);
            if (this.validate()) {

                this.$nextTick(() => {
                    this.submitted = true
                    console.log(this.form.building);
                    this.$store.dispatch('reservations/setReservationBuilding', { is_edit: this.form.is_edit, reservation_id: this.reservation.id, building_id: this.form.building.id })
                        .then(() => {
                            this.$emit('success')
                            this.showSuccessMsg()
                        })
                        .catch((error) => {
                            if (error.response.status == 400) {
                                this.showErrorMsg({
                                    message: error.response.data.message
                                })
                            } else {
                                this.showErrorMsg()
                            }
                        })

                })
            }
        },
        chkState(val) {
            const field = this.$v.form[val]
            return field.$dirty ? !field.$invalid : null
        },
        findFirstError(component = this) {
            if (component.state === false) {
                if (component.$refs.input) {
                    component.$refs.input.focus()
                    return true
                }
                if (component.$refs.check) {
                    component.$refs.check.focus()
                    return true
                }
            }
            let focused = false
            component.$children.some((child) => {
                focused = this.findFirstError(child)
                return focused
            })

            return focused
        },
        validate() {
            this.$v.$touch()
            this.$nextTick(() => this.findFirstError())
            return this.isValid
        },
        onCancel() {
            this.$emit('cancel')
        },
        onReset() {
            // Reset validation
            this.form = formShape
            this.submitted = false
            this.$nextTick(() => {
                this.$v.$reset()
            })
        },
    },
    created() {
        if (this.$store.state.buildings.simple.length == 0) {
            this.$store.dispatch('buildings/getSimpleBuildings')
        }
        this.form.building = this.reservation.building
        if(this.form.building != null && Object.keys(this.form.building).length > 0){
            this.form.is_edit = true;
        }
       
    }
}
</script>